<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div id="dashboard-analytics">
    <!-- ON OFF Dashboard Chart -->
    <div class="centerx">
      <vx-tooltip text="Toogle On/Off" position="left">
        <vs-button
          type="filled"
          size="large"
          icon-pack="feather"
          icon="icon-grid"
          color="warning"
          class="mr-2 vs-con-loading__container floatingButton"
          :style="
            isSmallerScreen
              ? `top: 130px;left: 20px;`
              : `top: 200px;left: 40px;`
          "
          @click="popupActivo = true"
        ></vs-button>
      </vx-tooltip>
      <vs-popup
        class="holamundo"
        title="On/Off Dashboard Information"
        :active.sync="popupActivo"
      >
        <div class="vx-row">
          <div class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5">
            <span>Total Vehicle</span>
            <vs-switch
              v-model="switchButton.total_vehicle"
              @click="enableDashboard('total_vehicle')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div>

          <!-- <div
            v-if="actor.privilege <= 3"
            class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5"
          >
            <span>Stock GPS</span>
            <vs-switch
              v-model="switchButton.stock_gps"
              @click="enableDashboard('stock_gps')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div> -->

          <div
            v-if="actor.privilege <= 3"
            class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5"
          >
            <span>Installed Today</span>
            <vs-switch
              v-model="switchButton.installed_today"
              @click="enableDashboard('installed_today')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div>

          <div
            v-if="actor.privilege >= 4"
            class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5"
          >
            <span>Moving Vehicle</span>
            <vs-switch
              v-model="switchButton.moving_vehicle"
              @click="enableDashboard('moving_vehicle')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div>

          <div
            v-if="actor.privilege >= 4"
            class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5"
          >
            <span>Stop Vehicle</span>
            <vs-switch
              v-model="switchButton.stop_vehicle"
              @click="enableDashboard('stop_vehicle')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div>

          <div class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5">
            <span>Unreported</span>
            <vs-switch
              v-model="switchButton.unreported_vehicle"
              @click="enableDashboard('unreported_vehicle')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div>
          <div class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5">
            <span>Expire Soon</span>
            <vs-switch
              v-model="switchButton.expired_soon"
              @click="enableDashboard('expired_soon')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div>
          <div class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5">
            <span>Expired</span>
            <vs-switch
              v-model="switchButton.expired"
              @click="enableDashboard('expired')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div>
          <div
            v-if="actor.privilege >= 4"
            class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5"
          >
            <span>GSM Signal</span>
            <vs-switch
              v-model="switchButton.gsm_signal"
              @click="enableDashboard('gsm_signal')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div>
          <div
            v-if="actor.privilege >= 4"
            class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5"
          >
            <span>Battery</span>
            <vs-switch
              v-model="switchButton.battery"
              @click="enableDashboard('battery')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div>
          <div
            v-if="actor.privilege >= 4"
            class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5"
          >
            <span>Top 10 Distance Driver</span>
            <vs-switch
              v-model="switchButton.top_10_distance_driver"
              @click="enableDashboard('top_10_distance_driver')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div>
          <div
            v-if="actor.privilege == 3"
            class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5"
          >
            <span>Installed Unit by Month</span>
            <vs-switch
              v-model="switchButton.installed_unit_by_month"
              @click="enableDashboard('installed_unit_by_month')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div>
          <!-- <div
            v-if="actor.privilege == 3"
            class="vx-col w-1/2 md:w-1/2 xl:w-1/2 mb-5"
          >
            <span>Top 10 of Branch (Month)</span>
            <vs-switch
              v-model="switchButton.top_10_branch_register_imei"
              @click="enableDashboard('top_10_branch_register_imei')"
            >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div> -->
        </div>
      </vs-popup>
    </div>
    <!-- END ON OFF Dashboard Chart -->

    <div class="vx-row">
      <div
        v-if="switchButton.total_vehicle == true"
        style="cursor: pointer"
        :class="cardClass1"
        @click="runFunction(cards.card1.detail)"
      >
        <statistics-card-line
          hideChart
          class="mb-base"
          :icon="cards.card1.icon"
          :statistic="cards.card1.total"
          :statisticTitle="cards.card1.title"
        />
      </div>

      <div
        v-if="actor.privilege >= 4 && switchButton.moving_vehicle == true"
        style="cursor: pointer"
        :class="cardClass1"
        @click="runFunction(cards.card2.detail)"
      >
        <statistics-card-line
          hideChart
          class="mb-base"
          :icon="cards.card2.icon"
          :statisticTitle="cards.card2.title"
          :statistic="cards.card2.total"
          color="success"
        />
      </div>
      <!-- <div
        v-else-if="actor.privilege <= 3 && switchButton.stock_gps == true"
        style="cursor: pointer"
        :class="cardClass1"
        @click="runFunction(cards.card2.detail)"
      >
        <statistics-card-line
          hideChart
          class="mb-base"
          :icon="cards.card2.icon"
          :statisticTitle="cards.card2.title"
          :statistic="cards.card2.total"
          color="success"
        />
      </div> -->

      <div
        v-if="actor.privilege >= 4 && switchButton.stop_vehicle == true"
        style="cursor: pointer"
        :class="cardClass1"
        @click="runFunction(cards.card3.detail)"
      >
        <statistics-card-line
          hideChart
          class="mb-base"
          :icon="cards.card3.icon"
          :statisticTitle="cards.card3.title"
          :statistic="cards.card3.total"
          color="warning"
        />
      </div>

      <div
        v-else-if="actor.privilege <= 3 && switchButton.installed_today == true"
        style="cursor: pointer"
        :class="cardClass1"
        @click="runFunction(cards.card3.detail)"
      >
        <statistics-card-line
          hideChart
          class="mb-base"
          :icon="cards.card3.icon"
          :statisticTitle="cards.card3.title"
          :statistic="cards.card3.total"
          color="warning"
        />
      </div>

      <div
        v-if="switchButton.unreported_vehicle == true"
        style="cursor: pointer"
        :class="cardClass1"
        @click="runFunction(cards.card4.detail)"
      >
        <statistics-card-line
          hideChart
          class="mb-base"
          :icon="cards.card4.icon"
          :statistic="cards.card4.total"
          :statisticTitle="cards.card4.title"
          color="danger"
        />
      </div>

      <div
        v-if="switchButton.expired_soon == true"
        style="cursor: pointer"
        :class="cardClass1"
        @click="runFunction(cards.card5.detail)"
      >
        <statistics-card-line
          hideChart
          class="mb-base"
          :icon="cards.card5.icon"
          :statistic="cards.card5.total"
          :statisticTitle="cards.card5.title"
          color="success"
        />
      </div>

      <div
        v-if="switchButton.expired == true"
        style="cursor: pointer"
        :class="cardClass1"
        @click="runFunction(cards.card6.detail)"
      >
        <statistics-card-line
          hideChart
          class="mb-base"
          :icon="cards.card6.icon"
          :statistic="cards.card6.total"
          :statisticTitle="cards.card6.title"
          color="warning"
        />
      </div>
    </div>

    <div v-show="actor.privilege >= 4" class="vx-row">
      <!-- GSM SIGNAL -->
      <div :class="cardClass2" v-if="switchButton.gsm_signal == true">
        <vx-card title="GSM Signal">
          <div slot="no-body">
            <!-- CHART -->
            <vue-apex-charts
              style="cursor: pointer"
              type="pie"
              height="334"
              class="my-12"
              :options="GsmSignalOptions"
              :series="signalData.series"
              @dataPointSelection="gsmChartClick"
            />

            <!-- CHART DATA -->
            <ul class="mb-1">
              <li
                class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0"
              >
                <span class="flex items-center">
                  <span
                    class="inline-block h-3 w-3 rounded-full mr-2"
                    :class="`bg-primary`"
                  ></span>
                  <span class="font-semibold">Good Signal</span>
                </span>
                <span>{{ gsm_signal.good }}</span>
              </li>
              <li
                class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0"
              >
                <span class="flex items-center">
                  <span
                    class="inline-block h-3 w-3 rounded-full mr-2"
                    :class="`bg-warning`"
                  ></span>
                  <span class="font-semibold">Medium Signal</span>
                </span>
                <span>{{ gsm_signal.medium }}</span>
              </li>
              <li
                class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0 mb-4"
              >
                <span class="flex items-center">
                  <span
                    class="inline-block h-3 w-3 rounded-full mr-2"
                    :class="`bg-danger`"
                  ></span>
                  <span class="font-semibold">Poor Signal</span>
                </span>
                <span>{{ gsm_signal.poor }}</span>
              </li>
            </ul>
          </div>
        </vx-card>
      </div>
      <!-- BATTERY STATUS -->
      <div :class="cardClass2" v-if="switchButton.battery == true">
        <vx-card title="Battery">
          <!-- CHART -->
          <div slot="no-body">
            <vue-apex-charts
              style="cursor: pointer"
              type="donut"
              height="340"
              class="mb-10"
              :options="batteryOptions"
              :series="batteryData.series"
              @dataPointSelection="batteryChartClick"
            />
          </div>

          <!-- CHART DATA -->
          <ul>
            <li
              class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0"
            >
              <span class="flex items-center">
                <span
                  class="inline-block h-3 w-3 rounded-full mr-2"
                  :class="`bg-primary`"
                ></span>
                <span class="font-semibold">Good</span>
              </span>
              <span>{{ battery_status.good }}</span>
            </li>
            <li
              class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0"
            >
              <span class="flex items-center">
                <span
                  class="inline-block h-3 w-3 rounded-full mr-2"
                  :class="`bg-warning`"
                ></span>
                <span class="font-semibold">Medium</span>
              </span>
              <span>{{ battery_status.medium }}</span>
            </li>
            <li
              class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0"
            >
              <span class="flex items-center">
                <span
                  class="inline-block h-3 w-3 rounded-full mr-2"
                  :class="`bg-danger`"
                ></span>
                <span class="font-semibold">Poor</span>
              </span>
              <span>{{ battery_status.poor }}</span>
            </li>
          </ul>
        </vx-card>
      </div>
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div
        :class="cardClass2"
        v-if="switchButton.top_10_distance_driver == true"
      >
        <vx-card title="Top 10 Distance Driver">
          <div slot="no-body" class="mt-4">
            <vs-table :data="topDistanceData" class="table-dark-inverted">
              <template slot="thead">
                <vs-th>DEVICE NAME</vs-th>
                <vs-th>PLATE</vs-th>
                <vs-th>DISTANCE</vs-th>
              </template>

              <template>
                <vs-tr v-for="(item, index) in topDistanceData" :key="index">
                  <vs-td>
                    <span>{{ item.device_name }}</span>
                  </vs-td>
                  <vs-td>
                    <span>{{ item.plate }}</span>
                  </vs-td>
                  <vs-td>
                    <span
                      >{{
                        (parseInt(item.mileage) / 1000)
                          .toFixed(0)
                          .toString()
                          .replace('.', ',')
                          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                      }}
                      KM</span
                    >
                    <vs-progress
                      :percent="
                        (item.mileage / topDistanceData[0].mileage) * 100
                      "
                      color="primary"
                    ></vs-progress>
                    <!-- <vs-progress v-else-if="item.mileage >= 50000 && item.mileage < 100000" :percent="50" color="warning"></vs-progress>
                    <vs-progress v-else-if="item.mileage >= 1000 && item.mileage < 50000"  :percent="30" color="success"></vs-progress>
                    <vs-progress v-else-if="item.mileage === 0" :percent="0" color="primary"></vs-progress> -->
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>

    <div
      v-if="actor.privilege === 3 || akses_total_top_10_branch"
      class="vx-row"
    >
      <div
        :class="cardClass2"
        v-if="
          actor.privilege === 3 && switchButton.installed_unit_by_month == true
        "
      >
        <vx-card title="">
          <vue-apex-charts
            type="bar"
            height="350"
            :options="lineChartSimple.chartOptions"
            :series="lineChartSimple.series"
          ></vue-apex-charts>
        </vx-card>
      </div>

      <div
        :class="cardClass2"
        v-if="switchButton.top_10_branch_register_imei == true"
      >
        <vx-card :title="'Top 10 ( Last Update ' + top10LastUpdate + ' )'">
          <div
            slot="no-body"
            style="
              height: 350px;
              line-height: 3em;
              overflow: auto;
              padding: 5px;
            "
            v-if="loadTop10Branch === false"
          >
            <h4
              style="
                margin-left: 18px;
                font-size: 14px;
                font-weight: 500;
                text-decoration: blink;
                color: #dc3545;
              "
              v-if="messageUpTo10Branch != ''"
            >
              {{ messageUpTo10Branch }}
            </h4>
            <vs-table :data="top10Branch" class="table-dark-inverted">
              <template slot="thead">
                <vs-th>NO</vs-th>
                <vs-th>BRANCH NAME</vs-th>
                <vs-th>&nbsp;</vs-th>
                <center>
                  <vs-th v-if="akses_total_top_10_branch">TOTAL UNIT</vs-th>
                </center>
                <vs-th v-if="akses_total_top_10_branch">LAST REGISTERED</vs-th>
              </template>

              <template v-if="top10Branch.length > 0">
                <vs-tr v-for="(item, index) in top10Branch" :key="index">
                  <vs-td>
                    <span>{{ index + 1 }}</span>
                  </vs-td>
                  <vs-td>
                    <span>{{ item.branch_name }}</span>
                  </vs-td>
                  <vs-td>
                    <center>
                      <template v-if="item.piala != '-'">
                        <img :src="item.piala" width="30" />
                      </template>
                      <span v-else> - </span>
                    </center>
                  </vs-td>
                  <vs-td v-if="akses_total_top_10_branch">
                    <center>
                      <span>{{ item.total_register }}</span>
                    </center>
                  </vs-td>
                  <vs-td v-if="akses_total_top_10_branch">
                    <span>{{ item.last_register_at }}</span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <dir v-else>Loading ...</dir>
        </vx-card>
      </div>
    </div>

    <div
      class="vx-row"
      v-if="actor.privilege === 3 || akses_total_top_10_branch"
    >
      <div
        style="
          cursor: pointer;
          height: 350px;
          line-height: 3em;
          overflow: auto;
          padding: 5px;
        "
        class="vx-col w-1/1 md:w-1/2 xl:w-1/3 transaction"
        v-for="(item, index) in top3BranchPerMonth"
        :key="index"
      >
        <vx-card
          :title="'Top Branch ' + list_month[item.month - 1] + ' ' + item.year"
        >
          <vs-table
            :data="top3BranchPerMonth"
            class="table-dark-inverted"
            style="margin-top: -20px"
          >
            <template slot="thead">
              <vs-th>NO</vs-th>
              <vs-th>BRANCH NAME</vs-th>
              <vs-th></vs-th>
            </template>

            <template>
              <vs-tr v-for="(item2, index2) in item.detail" :key="index2">
                <template v-if="item2.piala != '-'">
                  <vs-td>
                    <span>{{ index2 + 1 }}</span>
                  </vs-td>
                  <vs-td>
                    <span>{{ item2.branch.name }}</span>
                  </vs-td>
                  <vs-td>
                    <center>
                      <img :src="item2.piala" width="30" />
                    </center>
                  </vs-td>
                  <vs-td v-if="akses_total_top_10_branch">
                    <center>
                      <span>{{ item2.total_register }}</span>
                    </center>
                  </vs-td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>

    <vs-popup
      class="vs-popup-lg"
      classContent="popup-example"
      fullscreen
      :title="popupTitle"
      :active.sync="showPopup"
    >
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <!-- <vs-button
            :disabled="loading"
            v-if="typePopup !== 'battery' && typePopup !== 'signal'"
            id="exportBtn"
            icon-pack="feather"
            icon="icon-file-text"
            color="success"
            type="border"
            class="mb-4 md:mb-0 vs-con-loading__container"
            @click="Export(typePopup)"
            >Export</vs-button
          > -->

          <vs-button
            :disabled="loading"
            v-if="typePopup !== 'battery' && typePopup !== 'signal'"
            id="exportBtn2"
            icon-pack="feather"
            icon="icon-file-text"
            color="success"
            type="border"
            class="mb-4 md:mb-0 vs-con-loading__container"
            @click="handleDownload(typePopup)"
            >Export</vs-button
          >
        </div>

        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mr-2"
          v-if="typePopup !== 'battery' && typePopup !== 'signal'"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(250)">
              <span>250</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(500)">
              <span>500</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>No.</th>
            <th
              v-if="
                typePopup === 'expired_soon' ||
                typePopup === 'expired' ||
                typePopup === 'unreported_vehicle'
              "
            >
              Username
            </th>
            <th v-if="typePopup === 'expired_soon' || typePopup === 'expired'">
              Email
            </th>
            <th v-if="typePopup === 'expired_soon' || typePopup === 'expired'">
              Phone
            </th>
            <th v-if="typePopup === 'expired_soon' || typePopup === 'expired'">
              Plate
            </th>
            <th>Device name</th>
            <th>Imei</th>
            <th>GSM NO</th>
            <th>Last Update</th>
            <th v-if="typePopup !== 'expired_soon' && typePopup !== 'expired'">
              Speed
            </th>
            <th>Expired</th>
            <th v-if="typePopup !== 'expired_soon' && typePopup !== 'expired'">
              Lon
            </th>
            <th v-if="typePopup !== 'expired_soon' && typePopup !== 'expired'">
              Lat
            </th>
            <th v-if="typePopup !== 'expired_soon' && typePopup !== 'expired'">
              Address
            </th>
            <th v-if="typePopup === 'signal'">Gsm Signal</th>
            <th v-if="typePopup === 'battery'">Battery</th>
            <th v-if="typePopup !== 'signal' && typePopup !== 'battery'">
              Lifetime Warranty
            </th>
            <th v-if="typePopup === 'total_vehicle'">POI</th>
          </tr>
        </thead>
        <tbody v-if="loading">
          <tr>
            <td class="text-center" colspan="100">Loading...</td>
          </tr>
        </tbody>
        <tbody v-else-if="dataVehicle.length > 0">
          <tr v-for="(item, index) in dataVehicle" :key="index">
            <td>{{ (page - 1) * per_page + (index + 1) }}</td>
            <td
              v-if="
                typePopup === 'expired_soon' ||
                typePopup === 'expired' ||
                typePopup === 'unreported_vehicle'
              "
            >
              {{ item.username }}
            </td>
            <td v-if="typePopup === 'expired_soon' || typePopup === 'expired'">
              {{ item.email }}
            </td>
            <td v-if="typePopup === 'expired_soon' || typePopup === 'expired'">
              {{ item.phone }}
            </td>
            <td v-if="typePopup === 'expired_soon' || typePopup === 'expired'">
              {{ item.plate }}
            </td>
            <td>{{ item.device_name }}</td>
            <td>{{ item.imei }}</td>
            <td>{{ item.gsm_no }}</td>
            <td>{{ item.server_time }}</td>
            <td v-if="typePopup !== 'expired_soon' && typePopup !== 'expired'">
              {{ item.speed ? item.speed : 0 }} km
            </td>
            <td>{{ item.expired_gsm }}</td>
            <td v-if="typePopup !== 'expired_soon' && typePopup !== 'expired'">
              {{ item.lon }}
            </td>
            <td v-if="typePopup !== 'expired_soon' && typePopup !== 'expired'">
              {{ item.lat }}
            </td>
            <td v-if="typePopup !== 'expired_soon' && typePopup !== 'expired'">
              <div class="flex">
                <vs-button
                  v-if="!item.address && item.lon != 0"
                  style="font-size: 14px"
                  type="border"
                  size="small"
                  color="success"
                  class="mr-2 vs-con-loading__container"
                  @click="getAddress2(item, index, 'address')"
                >
                  Show Address
                </vs-button>

                <template v-else>
                  {{ item.address ? item.address : '-' }}
                </template>
              </div>
            </td>
            <td v-if="typePopup === 'signal'">
              {{ item.gsm_signal !== '' ? item.gsm_signal : '-' }}
            </td>
            <td v-if="typePopup === 'battery'">
              {{
                item.battery === ''
                  ? ''
                  : item.battery == '-1'
                  ? '100'
                  : item.battery
              }}
              %
            </td>
            <td v-if="typePopup !== 'signal' && typePopup !== 'battery'">
              {{ item.lifetime_warranty }}
            </td>
            <td v-if="typePopup === 'total_vehicle'">
              {{ item.poi_name }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="100">No Data Available</td>
          </tr>
        </tbody>
      </table>

      <vs-pagination :total="n_page" v-model="page"></vs-pagination>
    </vs-popup>

    <vs-popup
      class="vs-popup-lg"
      classContent="popup-example"
      :title="popupTitleStockGps"
      :active.sync="popUpDetailStockGps"
    >
      <div class="flex-grow">
        <vs-button
          :disabled="loading"
          v-if="dataStockGps.length > 0"
          id="exportBtn"
          icon-pack="feather"
          icon="icon-file-text"
          color="success"
          type="border"
          class="mb-4 md:mb-0 vs-con-loading__container"
          @click="Export(typePopup)"
          >Export</vs-button
        >
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>No.</th>
            <th>Gps Type</th>
            <th>Imei</th>
            <th>SN</th>
          </tr>
        </thead>
        <tbody v-if="loading">
          <tr>
            <td class="text-center" colspan="6">Loading...</td>
          </tr>
        </tbody>
        <tbody v-else-if="dataStockGps.length > 0">
          <tr v-for="(item, index) in dataStockGps" :key="index">
            <td>{{ (page - 1) * per_page + (index + 1) }}</td>
            <td>{{ item.ref_gps_type.name }}</td>
            <td>{{ item.imei }}</td>
            <td>{{ item.sn ? item.sn : '-' }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="6">No Data Available</td>
          </tr>
        </tbody>
      </table>
      <vs-pagination :total="n_page" v-model="page"></vs-pagination>
    </vs-popup>

    <vs-popup
      class="vs-popup-lg"
      classContent="popup-example"
      fullscreen
      :title="popupTitleInstalledToday"
      :active.sync="popUpDetailInstalledToday"
    >
      <div class="flex-grow">
        <vs-button
          :disabled="loading"
          v-if="dataInstalledToday.length > 0"
          id="exportBtn"
          icon-pack="feather"
          icon="icon-file-text"
          color="success"
          type="border"
          class="mb-4 md:mb-0 vs-con-loading__container"
          @click="Export(typePopup)"
          >Export</vs-button
        >
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>No.</th>
            <th>Username</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Plate No</th>
            <th>Gsm No</th>
            <th>Longitude</th>
            <th>Latitude</th>
            <th>Mileage</th>
            <th>Address</th>
            <th>Acc</th>
            <th>Activation Time</th>
          </tr>
        </thead>
        <tbody v-if="loading">
          <tr>
            <td class="text-center" colspan="14">Loading...</td>
          </tr>
        </tbody>
        <tbody v-else-if="dataInstalledToday.length > 0">
          <tr v-for="(item, index) in dataInstalledToday" :key="index">
            <td>{{ (page - 1) * per_page + (index + 1) }}</td>
            <td>{{ item.username }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.phone }}</td>
            <td>{{ item.plate }}</td>
            <td>{{ item.gsm_no }}</td>
            <td>{{ item.lon }}</td>
            <td>{{ item.lat }}</td>
            <td>
              {{
                (item.mileage / 1000)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }}
              Km
            </td>
            <td>{{ item.address }}</td>
            <td>{{ item.acc == 0 ? 'OFF' : 'ON' }}</td>
            <td>{{ item.installed_at }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="14">No Data Available</td>
          </tr>
        </tbody>
      </table>
      <vs-pagination :total="n_page" v-model="page"></vs-pagination>
    </vs-popup>

    <vs-popup
      class="vs-popup-lg"
      classContent="popup-example"
      :title="popupTitleInstalledByMonth"
      :active.sync="popUpDetailInstalledByMonth"
    >
      <div class="flex-grow">
        <vs-button
          :disabled="loading"
          v-if="dataDetailInstalledByMonth.length > 0"
          id="exportBtn"
          icon-pack="feather"
          icon="icon-file-text"
          color="success"
          type="border"
          class="mb-4 md:mb-0 vs-con-loading__container"
          @click="Export(typePopup)"
          >Export</vs-button
        >
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>No.</th>
            <th>Username</th>
            <th>Imei</th>
            <th>Plate No</th>
            <th>Device Name</th>
            <th>Gsm No</th>
            <th>Register Date</th>
          </tr>
        </thead>
        <tbody v-if="loading">
          <tr>
            <td class="text-center" colspan="7">Loading...</td>
          </tr>
        </tbody>
        <tbody v-else-if="dataDetailInstalledByMonth.length > 0">
          <tr v-for="(item, index) in dataDetailInstalledByMonth" :key="index">
            <td>{{ (page - 1) * per_page + (index + 1) }}</td>
            <td>{{ item.get_owner.username }}</td>
            <td>{{ item.imei }}</td>
            <td>{{ item.plate }}</td>
            <td>{{ item.device_name }}</td>
            <td>{{ item.gsm_no }}</td>
            <td>{{ item.register_date }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="7">No Data Available</td>
          </tr>
        </tbody>
      </table>
      <vs-pagination :total="n_page" v-model="page"></vs-pagination>
    </vs-popup>
  </div>
</template>

<style lang="css">
.floatingButton {
  z-index: 1000;
  position: fixed;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 50px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
}

.transaction {
  transition: width 1s;
  -webkit-transition: width 1s;
}
</style>

<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'

import FileDownload from 'js-file-download'

export default {
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      popupActivo: false,
      access_chart: [],
      switchButton: {
        total_vehicle: false,
        stock_gps: false,
        installed_today: false,
        moving_vehicle: false,
        stop_vehicle: false,
        unreported_vehicle: false,
        expired_soon: false,
        expired: false,
        gsm_signal: false,
        battery: false,
        top_10_distance_driver: false,
        installed_unit_by_month: false,
        top_10_branch_register_imei: true
      },
      switchButtonCondition: {
        move_or_stock: false,
        stop_or_installed: false
      },

      cardClass1: '',
      cardClass2: '',

      tempCardBaris1: 0,
      tempCardBaris2: 0,

      ListChart: [],

      now: new Date().getTime() / 1000,
      actor: {},

      loading: true,
      page: 1,
      per_page: 10,
      row_total: 0,

      showPopup: false,
      popupTitle: '',
      typePopup: '',
      dataVehicle: [],

      popUpDetailStockGps: false,
      popupTitleStockGps: '',
      typePopupStockGps: '',
      dataStockGps: [],

      popUpDetailInstalledToday: false,
      popupTitleInstalledToday: '',
      typePopupInstalledToday: '',
      dataInstalledToday: [],

      popUpDetailInstalledByMonth: false,
      popupTitleInstalledByMonth: '',
      dataDetailInstalledByMonth: [],
      month_chart: '',
      year_chart: '',

      signal_type: '',
      battery_status_type: '',

      token: '',
      cards: {
        card1: {
          total: 0,
          icon: 'RefreshCwIcon',
          title: 'Loading ...',
          detail: 'detailTotalVehicle'
        },

        card2: {
          total: 0,
          icon: 'RefreshCwIcon',
          title: 'Loading ...',
          detail: ''
        },

        card3: {
          total: 0,
          icon: 'RefreshCwIcon',
          title: 'Loading ...',
          detail: ''
        },

        card4: {
          total: 0,
          icon: 'RefreshCwIcon',
          title: 'Loading ...',
          detail: 'detailUnreportedVehicle'
        },

        card5: {
          total: 0,
          icon: 'RefreshCwIcon',
          title: 'Loading ...',
          detail: 'detailExpiredSoon'
        },

        card6: {
          total: 0,
          icon: 'RefreshCwIcon',
          title: 'Loading ...',
          detail: 'detailExpired'
        }
      },

      gsm_signal: {
        good: 0,
        medium: 0,
        poor: 0
      },

      battery_status: {
        good: 0,
        medium: 0,
        poor: 0
      },

      signalData: {},

      GsmSignalOptions: {
        labels: ['Good Signal', 'Medium Signal', 'Poor Signal'],
        dataLabels: {
          enabled: false
        },
        legend: { show: false },
        chart: {
          type: 'pie',
          offsetY: 0,
          dropShadow: {
            enabled: false,
            blur: 5,
            left: 1,
            top: 1,
            opacity: 0.2
          },
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: 5
        },
        colors: ['#479DD7', '#FF9F43', '#EA5455'],
        fill: {
          type: 'gradient',
          gradient: {
            gradientToColors: ['#76B6E1', '#FFC085', '#f29292']
          }
        },
        tooltip: {
          enabled: true
        }
      },

      batteryOptions: {
        labels: ['Good', 'Medium', 'Poor'],
        dataLabels: {
          enabled: false
        },
        legend: { show: false },
        chart: {
          offsetY: 30,
          type: 'donut',
          toolbar: {
            show: false
          }
        },
        stroke: { width: 0 },
        colors: ['#479DD7', '#FF9F43', '#EA5455'],
        fill: {
          type: 'gradient',
          gradient: {
            gradientToColors: ['#76B6E1', '#FFC085', '#f29292']
          }
        },
        tooltip: {
          enabled: true
        }
      },

      topDistanceData: [],

      batteryData: {
        analyticsData: [
          {
            device: 'Good',
            icon: 'MonitorIcon',
            color: 'primary',
            sessionsPercentage: 58.6,
            comparedResultPercentage: 2
          },
          {
            device: 'Medium',
            icon: 'SmartphoneIcon',
            color: 'warning',
            sessionsPercentage: 34.9,
            comparedResultPercentage: 8
          },
          {
            device: 'Poor',
            icon: 'TabletIcon',
            color: 'danger',
            sessionsPercentage: 6.5,
            comparedResultPercentage: -5
          }
        ]
      },

      lineChartSimple: {
        series: [],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false
            },
            events: {
              dataPointSelection: (event, chartContext, config) => {
                // this.month_chart = config.dataPointIndex + 1
                let slc_categories =
                  config.w.config.xaxis.categories[config.dataPointIndex]

                this.page = 1
                this.month_chart =
                  this.list_month2.indexOf(slc_categories.split(' ')[0]) + 1
                this.year_chart = slc_categories.split(' ')[1]
                this.detailInstalledByMonth()
              }
            }
          },
          colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text: 'Installed Unit by Month',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            type: 'category',
            categories: [
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'May',
              'Jun',
              'Jul',
              'Aug',
              'Sep',
              'Oct',
              'Nov',
              'Dec'
            ]
          }
        }
      },

      top10Branch: [],
      top10LastUpdate: '',
      loadTop10Branch: false,
      top3BranchPerMonth: [],

      list_akses_total_top_10_branch: [
        'super',
        'adminss',
        'sby_rob',
        'sscdemo',
        'ptk_owner'
      ],
      akses_total_top_10_branch: false,
      current_month: 0,
      current_year: 0,
      list_month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      list_month2: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ],

      block_top_rank: false,
      messageUpTo10Branch: ''
    }
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 992
    },

    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    chartCategories() {
      const x = []
      let now = new Date()
      let month = now.getMonth() + 1
      let year = now.getFullYear()

      const monthName = [
        '',
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]

      for (let j = 11; j >= 0; j--) {
        let m = month - j
        let y = year

        if (m < 1) {
          m += 12
          y--
        }

        x.push(`${monthName[m]} ${y}`)
      }

      return x
    }
  },

  watch: {
    page() {
      this.loading = true
      if (this.typePopup === 'signal') {
        this.getDetailSignal()
      } else if (this.typePopup === 'battery') {
        this.getDetailBatteryStatus()
      } else if (this.typePopup === 'total_vehicle') {
        this.detailTotalVehicle()
      } else if (this.typePopup === 'stock_gps') {
        this.detailStockGps()
      } else if (this.typePopup === 'installed_today') {
        this.detailInstalledToday()
      } else if (this.typePopup === 'parking_vehicle') {
        this.detailParkingVehicle()
      } else if (this.typePopup === 'moving_vehicle') {
        this.detailMovingVehicle()
      } else if (this.typePopup === 'unreported_vehicle') {
        this.detailUnreportedVehicle()
      } else if (this.typePopup === 'expired_soon') {
        this.detailExpiredSoon()
      } else if (this.typePopup === 'expired') {
        this.detailExpired()
      } else if (this.typePopup === 'detail_installed_by_month') {
        this.detailInstalledByMonth()
      }
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else {
        if (this.typePopup === 'total_vehicle') {
          this.detailTotalVehicle()
        } else if (this.typePopup === 'stock_gps') {
          this.detailStockGps()
        } else if (this.typePopup === 'installed_today') {
          this.detailInstalledToday()
        } else if (this.typePopup === 'parking_vehicle') {
          this.detailParkingVehicle()
        } else if (this.typePopup === 'moving_vehicle') {
          this.detailMovingVehicle()
        } else if (this.typePopup === 'unreported_vehicle') {
          this.detailUnreportedVehicle()
        } else if (this.typePopup === 'expired_soon') {
          this.detailExpiredSoon()
        } else if (this.typePopup === 'expired') {
          this.detailExpired()
        } else if (this.typePopup === 'detail_installed_by_month') {
          this.detailInstalledByMonth()
        }
      }
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.block_top_rank = this.actor.block_top_rank
        this.switchButton.top_10_branch_register_imei = this.block_top_rank
          ? false
          : true

        if (this.actor.chart_access != null)
          this.access_chart = this.actor.chart_access
            .replace('[', '')
            .replace(']', '')
            .split(',')
            .map((x) => +x)

        if (this.list_akses_total_top_10_branch.includes(this.actor.username)) {
          this.akses_total_top_10_branch = true
        }

        // this.list_akses_total_top_10_branch.map((item) => {
        //   if (item === this.actor.username) {
        //     this.akses_total_top_10_branch = true
        //   }
        // })

        this.getListChart()

        //dibikin statis muncul, tidak bisa enable disable

        if (
          this.actor.privilege === 3 ||
          this.akses_total_top_10_branch === true
        ) {
          this.getTop3BranchPerMonth()

          if (!this.block_top_rank) {
            this.getTop10BranchRegisterImei()
            this.tempCardBaris2++
          }
        }
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {
    setInterval(() => {
      this.now = new Date().getTime() / 1000
    }, 1000)

    this.getDataInterval()

    setInterval(() => {
      if (
        (!this.block_top_rank && this.actor.privilege === 3) ||
        this.akses_total_top_10_branch
      ) {
        this.getTop10BranchRegisterImei()
      }
    }, 100000)

    const d = new Date()
    this.current_month = d.getMonth()
    this.current_year = d.getFullYear()
  },

  methods: {
    updatePerPage(n) {
      this.per_page = n
    },

    enableDashboard(name) {
      if (!this.switchButton[name] == false) {
        this.ListChart.map((item) => {
          let selected = item.switch_name.indexOf(name)
          if (selected > -1) {
            let index = this.access_chart.indexOf(item.number)
            if (index > -1) {
              this.access_chart.splice(index, 1)

              if (
                name == 'gsm_signal' ||
                name == 'battery' ||
                name == 'top_10_distance_driver' ||
                name == 'installed_unit_by_month' ||
                name == 'top_10_branch_register_imei'
              ) {
                this.tempCardBaris2--
              } else {
                this.tempCardBaris1--
              }
            }
          }
        })
      } else {
        this.ListChart.map((item) => {
          // let selected = item.switch_name.includes(name)
          // if (selected > -1) {
          if (item.switch_name == name) {
            let cek_nol = this.access_chart.includes(0)
            if (cek_nol) this.access_chart = []

            this.access_chart.push(item.number)

            if (item.switch_name == 'gsm_signal') {
              this.getGsmSignal()
              this.tempCardBaris2++
            } else if (item.switch_name == 'battery') {
              this.getBatteryStatus()
              this.tempCardBaris2++
            } else if (item.switch_name == 'top_10_distance_driver') {
              this.getTopDistance()
              this.tempCardBaris2++
            } else if (item.switch_name == 'installed_unit_by_month') {
              this.getImeiInYear()
              this.tempCardBaris2++

              this.lineChartSimple.chartOptions.xaxis.categories =
                this.chartCategories
            } else if (item.switch_name == 'top_10_branch_register_imei') {
              this.getTop10BranchRegisterImei()
              this.tempCardBaris2++
            } else {
              this.tempCardBaris1++
            }
          }
        })
      }

      this.changeClassCard1()
      this.changeClassCard2()
      this.on_of_chart(this.access_chart)
    },

    on_of_chart(charts) {
      let url = `${this.$api.endpoint}/user/update_chart_access/${this.actor.id}`

      this.$http
        .post(
          url,
          {
            charts: charts
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          // this.$vs.loading.close('#submitBtn > .con-vs-loading')
          // this.notify = res.data.message.split('_').join(' ')
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    runFunction(name) {
      this[name]()
    },

    getListChart() {
      this.$http
        .get(`${this.$api.endpoint}/dashboard_chart/all`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          this.ListChart = data

          this.ListChart.map((item) => {
            let selected = this.access_chart.indexOf(item.number)
            if (selected > -1) {
              this.switchButton[item.switch_name] = true
            }
          })

          if (this.actor.privilege === 3) {
            if (this.switchButton.installed_unit_by_month == true) {
              this.getImeiInYear()
              this.tempCardBaris2++

              this.lineChartSimple.chartOptions.xaxis.categories =
                this.chartCategories
            }

            // if (this.switchButton.top_10_branch_register_imei == true) {
            // this.getTop10BranchRegisterImei()
            // this.tempCardBaris2++
            // }
          }

          if (this.actor.privilege > 3) {
            if (this.switchButton.gsm_signal == true) {
              this.getGsmSignal()
              this.tempCardBaris2++
            }

            if (this.switchButton.battery == true) {
              this.getBatteryStatus()
              this.tempCardBaris2++
            }

            if (this.switchButton.top_10_distance_driver == true) {
              this.getTopDistance()
              this.tempCardBaris2++
            }
          }

          if (this.switchButton.total_vehicle == true) this.tempCardBaris1++
          if (this.switchButton.stock_gps == true) this.tempCardBaris1++
          if (this.switchButton.moving_vehicle == true) this.tempCardBaris1++
          if (this.switchButton.installed_today == true) this.tempCardBaris1++
          if (this.switchButton.stop_vehicle == true) this.tempCardBaris1++
          if (this.switchButton.unreported_vehicle == true)
            this.tempCardBaris1++
          if (this.switchButton.expired_soon == true) this.tempCardBaris1++
          if (this.switchButton.expired == true) this.tempCardBaris1++

          this.changeClassCard1()
          this.changeClassCard2()

          this.getStatistic()
        })
        .catch((error) => {
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    changeClassCard1() {
      if (this.tempCardBaris1 == 1)
        var value = 'vx-col w-full lg:w-1/1 transaction'
      else if (this.tempCardBaris1 == 2)
        var value = 'vx-col w-1/2 md:w-1/2 xl:w-1/2 transaction'
      else if (this.tempCardBaris1 == 3)
        var value = 'vx-col w-1/2 md:w-1/3 xl:w-1/3 transaction'
      else if (this.tempCardBaris1 == 4)
        var value = 'vx-col w-1/2 md:w-1/3 xl:w-1/4 transaction'
      else if (this.tempCardBaris1 == 5)
        var value = 'vx-col w-1/2 md:w-1/3 xl:w-1/5 transaction'
      else if (this.tempCardBaris1 == 6)
        var value = 'vx-col w-1/2 md:w-1/3 xl:w-1/6 transaction'

      this.cardClass1 = value
    },

    changeClassCard2() {
      if (this.tempCardBaris2 == 1)
        var value = 'vx-col w-full lg:w-1/1 mb-base transaction'
      else if (this.tempCardBaris2 == 2)
        var value = 'vx-col w-full lg:w-1/2 mb-base transaction'
      else if (this.tempCardBaris2 == 3)
        var value = 'vx-col w-full lg:w-1/3 mb-base transaction'

      this.cardClass2 = value
    },

    detailTotalVehicle() {
      this.popUpDetailStockGps = false
      this.popUpDetailInstalledToday = false
      if (this.typePopup !== 'total_vehicle') {
        this.page = 1
        this.per_page = 10
      }

      this.showPopup = true
      this.popupTitle = 'Detail Vehicle'
      this.typePopup = 'total_vehicle'
      this.loading = true
      this.dataVehicle = []

      this.$http
        .get(
          `${this.$api.endpoint}/dashboard/detail_total_vehicle?page=${this.page}&per_page=${this.per_page}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          var data = res.data.message.data
          this.row_total = res.data.message.total
          this.dataVehicle = data

          this.dataVehicle.map((item, index) => {
            this.dataVehicle[index].no =
              (this.page - 1) * this.per_page + (index + 1)
          })

          this.loading = false
          this.getAddress()
        })
        .catch((error) => {
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },
    detailMovingVehicle() {
      this.popUpDetailStockGps = false
      this.popUpDetailInstalledToday = false
      if (this.typePopup !== 'moving_vehicle') {
        this.page = 1
        this.per_page = 10
      }

      this.showPopup = true
      this.popupTitle = 'Detail Moving Vehicle'
      this.typePopup = 'moving_vehicle'
      this.loading = true
      this.dataVehicle = []

      this.$http
        .get(
          `${this.$api.endpoint}/dashboard/detail_moving_vehicle?page=${this.page}&per_page=${this.per_page}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          var data = res.data.message.data
          this.row_total = res.data.message.total
          this.dataVehicle = data

          this.dataVehicle.map((item, index) => {
            this.dataVehicle[index].no =
              (this.page - 1) * this.per_page + (index + 1)
          })

          this.loading = false
          this.getAddress()
        })
        .catch((error) => {
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    detailParkingVehicle() {
      this.popUpDetailStockGps = false
      this.popUpDetailInstalledToday = false
      if (this.typePopup !== 'parking_vehicle') {
        this.page = 1
        this.per_page = 10
      }

      this.showPopup = true
      this.popupTitle = 'Detail Stop Vehicle'
      this.typePopup = 'parking_vehicle'
      this.loading = true
      this.dataVehicle = []

      this.$http
        .get(
          `${this.$api.endpoint}/dashboard/detail_parking_vehicle?page=${this.page}&per_page=${this.per_page}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          var data = res.data.message.data
          this.row_total = res.data.message.total
          this.dataVehicle = data

          this.dataVehicle.map((item, index) => {
            this.dataVehicle[index].no =
              (this.page - 1) * this.per_page + (index + 1)
          })

          this.loading = false
          this.getAddress()
        })
        .catch((error) => {
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    detailUnreportedVehicle() {
      this.popUpDetailStockGps = false
      this.popUpDetailInstalledToday = false
      if (this.typePopup !== 'unreported_vehicle') {
        this.page = 1
        this.per_page = 10
      }

      this.showPopup = true
      this.popupTitle = 'Detail Unreported Vehicle'
      this.typePopup = 'unreported_vehicle'
      this.loading = true
      this.dataVehicle = []

      this.$http
        .get(
          `${this.$api.endpoint}/dashboard/detail_unreported_vehicle?page=${this.page}&per_page=${this.per_page}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          var data = res.data.message.data
          this.row_total = res.data.message.total
          this.dataVehicle = data

          this.dataVehicle.map((item, index) => {
            this.dataVehicle[index].no =
              (this.page - 1) * this.per_page + (index + 1)
          })

          this.loading = false
          this.getAddress()
        })
        .catch((error) => {
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    detailExpiredSoon() {
      this.popUpDetailStockGps = false
      this.popUpDetailInstalledToday = false
      if (this.typePopup !== 'expired_soon') {
        this.page = 1
        this.per_page = 10
      }

      this.showPopup = true
      this.popupTitle = 'Detail Expire Soon Vehicle'
      this.typePopup = 'expired_soon'
      this.loading = true
      this.dataVehicle = []

      this.$http
        .get(
          `${this.$api.endpoint}/dashboard/detail_expired_soon?page=${this.page}&per_page=${this.per_page}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          var data = res.data.message.data
          this.row_total = res.data.message.total
          this.dataVehicle = data

          this.dataVehicle.map((item, index) => {
            this.dataVehicle[index].no =
              (this.page - 1) * this.per_page + (index + 1)
          })

          this.loading = false
          // this.getAddress()
        })
        .catch((error) => {
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    detailExpired() {
      this.popUpDetailStockGps = false
      this.popUpDetailInstalledToday = false
      if (this.typePopup !== 'expired') {
        this.page = 1
        this.per_page = 10
      }

      this.showPopup = true
      this.popupTitle = 'Detail Expired Vehicle'
      this.typePopup = 'expired'
      this.loading = true
      this.dataVehicle = []

      this.$http
        .get(
          `${this.$api.endpoint}/dashboard/detail_expired?page=${this.page}&per_page=${this.per_page}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          var data = res.data.message.data
          this.row_total = res.data.message.total
          this.dataVehicle = data

          this.dataVehicle.map((item, index) => {
            this.dataVehicle[index].no =
              (this.page - 1) * this.per_page + (index + 1)
          })

          this.loading = false
          // this.getAddress()
        })
        .catch((error) => {
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    detailStockGps() {
      this.showPopup = false
      this.popUpDetailInstalledToday = false
      if (this.typePopup !== 'stock_gps') {
        this.page = 1
        this.per_page = 10
      }

      this.popUpDetailStockGps = true
      this.popupTitleStockGps = 'Detail Stock Gps'
      this.typePopup = 'stock_gps'
      this.loading = true
      this.dataStockGps = []

      this.$http
        .get(
          `${this.$api.endpoint}/dashboard/detail_stock_gps?page=${this.page}&per_page=${this.per_page}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          var data = res.data.message.data
          this.row_total = res.data.message.total
          this.dataStockGps = data

          this.dataVehicle.map((item, index) => {
            this.dataVehicle[index].no =
              (this.page - 1) * this.per_page + (index + 1)
          })

          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    detailInstalledToday() {
      this.showPopup = false
      this.popUpDetailStockGps = false
      if (this.typePopup !== 'installed_today') {
        this.page = 1
        this.per_page = 10
      }

      this.popUpDetailInstalledToday = true
      this.popupTitleInstalledToday = 'Detail Installed Today'
      this.typePopup = 'installed_today'
      this.loading = true
      this.dataInstalledToday = []

      this.$http
        .get(
          `${this.$api.endpoint}/dashboard/detail_installed_today?page=${this.page}&per_page=${this.per_page}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          var data = res.data.message.data
          this.row_total = res.data.message.total
          this.dataInstalledToday = data

          this.dataVehicle.map((item, index) => {
            this.dataVehicle[index].no =
              (this.page - 1) * this.per_page + (index + 1)
          })

          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    getDetailSignal() {
      this.popUpDetailStockGps = false
      this.popUpDetailInstalledToday = false
      if (this.typePopup !== 'signal') {
        this.page = 1
        this.per_page = 10
      }

      this.showPopup = true
      this.popupTitle = 'Detail GSM Signal'
      this.typePopup = 'signal'

      this.dataVehicle = []
      this.loading = true
      this.$http
        .get(
          `${this.$api.endpoint}/dashboard/detail_gsm_signal?page=${this.page}&per_page=${this.per_page}&type=${this.signal_type}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          var data = res.data.message.data
          this.row_total = res.data.message.total
          this.dataVehicle = data

          this.loading = false
          this.getAddress()
        })
        .catch((error) => {
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    getDetailBatteryStatus() {
      this.popUpDetailStockGps = false
      this.popUpDetailInstalledToday = false
      if (this.typePopup !== 'battery') {
        this.page = 1
        this.per_page = 10
      }

      this.showPopup = true
      this.popupTitle = 'Detail Battery Status'
      this.typePopup = 'battery'

      this.dataVehicle = []
      this.loading = true

      this.$http
        .get(
          `${this.$api.endpoint}/dashboard/detail_battery_status?page=${this.page}&per_page=${this.per_page}&type=${this.battery_status_type}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          var data = res.data.message.data
          this.row_total = res.data.message.total
          this.dataVehicle = data

          this.loading = false
          this.getAddress()
        })
        .catch((error) => {
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    gsmChartClick(event, ctx, config) {
      this.signal_type = config.dataPointIndex
      this.getDetailSignal()
    },

    batteryChartClick(event, ctx, config) {
      this.battery_status_type = config.dataPointIndex
      this.getDetailBatteryStatus()
    },

    getStatistic() {
      this.$http
        .get(`${this.$api.endpoint}/dashboard/statistics`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data

          this.cards.card1.total = data.total_vehicle
          this.cards.card1.title = 'Total Vehicle'
          this.cards.card1.icon = 'TruckIcon'

          if (this.actor.privilege <= 3) {
            this.cards.card2.total = data.stock_gps
            this.cards.card2.title = 'Stock Gps'
            this.cards.card2.icon = 'ArchiveIcon'
            this.cards.card2.detail = 'detailStockGps'
          } else {
            this.cards.card2.total = data.moving_vehicle
            this.cards.card2.title = 'Moving Vehicle'
            this.cards.card2.icon = 'MonitorIcon'
            this.cards.card2.detail = 'detailMovingVehicle'
          }

          if (this.actor.privilege <= 3) {
            this.cards.card3.total = data.installed_today
            this.cards.card3.title = 'Installed Today'
            this.cards.card3.icon = 'CreditCardIcon'
            this.cards.card3.detail = 'detailInstalledToday'
          } else {
            this.cards.card3.total = data.parking
            this.cards.card3.title = 'Stop Vehicle'
            this.cards.card3.icon = 'FlagIcon'
            this.cards.card3.detail = 'detailParkingVehicle'
          }

          this.cards.card4.total = data.unreported_vehicle
          this.cards.card4.title = 'Unreported Vehicle'
          this.cards.card4.icon = 'SlashIcon'

          this.cards.card5.total = data.expired_soon
          this.cards.card5.title = 'Expire Soon'
          this.cards.card5.icon = 'ClockIcon'

          this.cards.card6.total = data.expired
          this.cards.card6.title = 'Expired'
          this.cards.card6.icon = 'LockIcon'

          // console.log(this.tempCardBaris1)
        })
    },

    getGsmSignal() {
      this.$http
        .get(`${this.$api.endpoint}/dashboard/gsm_signal`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          this.gsm_signal.good = data.good
          this.gsm_signal.medium = data.medium
          this.gsm_signal.poor = data.poor

          this.signalData = {
            series: [data.good, data.medium, data.poor]
          }
        })
    },

    getBatteryStatus() {
      this.$http
        .get(`${this.$api.endpoint}/dashboard/battery_status`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data

          this.batteryData = {
            series: [data.good, data.medium, data.poor]
          }

          this.battery_status.good = data.good
          this.battery_status.medium = data.medium
          this.battery_status.poor = data.poor
        })
    },

    getTopDistance() {
      this.$http
        .get(`${this.$api.endpoint}/dashboard/top_distance`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          this.topDistanceData = data
        })
    },

    getAddress() {
      this.dataVehicle.map((item, index) => {
        setTimeout(() => {
          this.$http
            .get(`${this.$api.base_url}/api/address`, {
              params: {
                latitude: item.lat,
                longitude: item.lon
              }
            })
            .then((res) => {
              this.dataVehicle[index].address = res.data.message
            })
        }, index * 300)
      })
    },

    getAddress2(item, index, param) {
      this.$http
        .get(`${this.$api.base_url}/api/address`, {
          params: {
            latitude: item.lat,
            longitude: item.lon
          }
        })
        .then((res) => {
          this.dataVehicle[index][param] = res.data.message
        })
    },

    getImeiInYear() {
      this.$http
        .get(`${this.$api.endpoint}/dashboard/imei_in_year`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data

          this.lineChartSimple.series = [
            {
              name: 'Installed unit by month',
              data: data.series
            }
          ]
        })
    },

    getTop10BranchRegisterImei() {
      this.loadTop10Branch = true
      this.$http
        .get(`${this.$api.endpoint}/dashboard/top_10_branch_register_imei`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loadTop10Branch = false

          var data = res.data.message
          this.top10Branch = data.data

          let jarak_total_unit = data.last_rank_total - data.my_total_unit
          if (
            jarak_total_unit > 0 &&
            this.actor.privilege == 3 &&
            this.actor.branch != 0
          ) {
            this.messageUpTo10Branch = `${
              jarak_total_unit + 1
            } more units left to enter the top 10`
          } else {
            this.messageUpTo10Branch = ''
          }

          let piala1 = `${this.publicPath}thropy/1.png`
          let piala2 = `${this.publicPath}thropy/2.png`
          let piala3 = `${this.publicPath}thropy/3.png`

          let jumlah = 0
          let index = 0
          let current_piala

          this.top10Branch.map((item, i) => {
            if (i == 0) {
              this.top10Branch[i].piala = piala1
              jumlah = item.total_register
              index = 1
              current_piala = piala1
            } else {
              // ===== logic lama tutup dulu =====
              // if (item.total_register == jumlah) {
              //   this.top10Branch[i].piala = current_piala
              //   jumlah = item.total_register
              //   current_piala = current_piala
              // } else {
              //   jumlah = item.total_register
              //   index++

              //   if (index <= 3) {
              //     if (index == 2) {
              //       this.top10Branch[i].piala = piala2
              //       current_piala = piala2
              //     } else if (index == 3) {
              //       this.top10Branch[i].piala = piala3
              //       current_piala = piala3
              //     }
              //   } else {
              //     this.top10Branch[i].piala = '-'
              //     current_piala = '-'
              //   }
              // }

              // ===== logic baru buka dulu =====
              jumlah = item.total_register
              index++

              if (index <= 3) {
                if (index == 2) {
                  this.top10Branch[i].piala = piala2
                  current_piala = piala2
                } else if (index == 3) {
                  this.top10Branch[i].piala = piala3
                  current_piala = piala3
                }
              } else {
                this.top10Branch[i].piala = '-'
                current_piala = '-'
              }
            }
          })

          if (data.last_update !== '') {
            let date = new Date(Date.parse(data.last_update))
            let time = data.last_update.split(' ')

            let tgl = date.getDate()
            let bulan = date.toLocaleString('default', { month: 'long' })
            let tahun = date.getFullYear()
            // let jam = date.getHours()
            // let menit = date.getMinutes()
            // let detik = date.getSeconds()

            this.top10LastUpdate = `${tgl} ${bulan} ${tahun} ${time[1]}`
          } else {
            this.last_update = ''
          }
        })
    },

    getTop3BranchPerMonth() {
      this.$http
        .get(`${this.$api.endpoint}/dashboard/top_3_branch`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          this.top3BranchPerMonth = data

          let piala1 = `${this.publicPath}thropy/1.png`
          let piala2 = `${this.publicPath}thropy/2.png`
          let piala3 = `${this.publicPath}thropy/3.png`

          let jumlah = 0
          let index = 0
          let current_piala

          this.top3BranchPerMonth.map((item, i) => {
            item.detail.map((item2, i2) => {
              if (i2 == 0) {
                this.top3BranchPerMonth[i].detail[i2].piala = piala1
                jumlah = item2.total_register
                index = 1
                current_piala = piala1
              } else {
                // ===== logic lama tutup dulu =====
                // if (item2.total_register == jumlah) {
                //   this.top3BranchPerMonth[i].detail[i2].piala = current_piala
                //   jumlah = item2.total_register
                //   current_piala = current_piala
                // } else {
                //   jumlah = item2.total_register
                //   index++

                //   if (index <= 10) {
                //     if (index == 2) {
                //       this.top3BranchPerMonth[i].detail[i2].piala = piala2
                //       current_piala = piala2
                //     } else if (index == 3) {
                //       this.top3BranchPerMonth[i].detail[i2].piala = piala3
                //       current_piala = piala3
                //     } else {
                //       this.top3BranchPerMonth[i].detail[i2].piala = ''
                //       current_piala = ''
                //     }
                //   } else {
                //     this.top3BranchPerMonth[i].detail[i2].piala = '-'
                //     current_piala = '-'
                //   }
                // }

                // ===== logic baru buka dulu =====
                jumlah = item2.total_register
                index++

                if (index <= 10) {
                  if (index == 2) {
                    this.top3BranchPerMonth[i].detail[i2].piala = piala2
                    current_piala = piala2
                  } else if (index == 3) {
                    this.top3BranchPerMonth[i].detail[i2].piala = piala3
                    current_piala = piala3
                  } else {
                    this.top3BranchPerMonth[i].detail[i2].piala = ''
                    current_piala = ''
                  }
                } else {
                  this.top3BranchPerMonth[i].detail[i2].piala = '-'
                  current_piala = '-'
                }
              }
            })
          })
        })
    },

    Export(type) {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      let params = {}
      if (type == 'detail_installed_by_month') {
        params = {
          month: this.month_chart - 1,
          year: this.year_chart
        }
      }

      this.$http
        .get(`${this.$api.endpoint}/dashboard/export/${type}`, {
          responseType: 'blob',
          params: params,
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)

          let filename = `${type}_${parseInt(this.now)}.xlsx`

          if (type == 'detail_installed_by_month') {
            filename = `${type}_${this.list_month[this.month_chart - 1]}_${
              this.year_chart
            }.xlsx`
          }

          FileDownload(res.data, filename)
        })
        .catch((error) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    getDataInterval() {
      setInterval(() => {
        if (this.$route.name == 'home') {
          if (this.actor.privilege > 3) {
            this.getGsmSignal()
            this.getBatteryStatus()
            this.getTopDistance()
          } else if (this.actor.privilege == 3) {
            this.getImeiInYear()
            // this.getTop10BranchRegisterImei()
          }
          this.getStatistic()
        }
      }, 300000) // interval 5 menit
    },

    detailInstalledByMonth() {
      this.popUpDetailInstalledByMonth = true
      this.popupTitleInstalledByMonth =
        'Detail Installed By Month (' +
        this.list_month2[this.month_chart - 1] +
        ' ' +
        this.year_chart +
        ')'
      this.typePopup = 'detail_installed_by_month'

      this.loading = true
      this.dataDetailInstalledByMonth = []
      this.$http
        .get(`${this.$api.endpoint}/dashboard/detail_imei_in_year`, {
          params: {
            page: this.page,
            per_page: this.per_page,
            month: this.month_chart,
            year: this.year_chart
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          this.dataDetailInstalledByMonth = data
          this.row_total = res.data.message.total
          this.loading = false
        })
    },

    handleDownload(type) {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn2',
        scale: 0.45
      })

      import('@/vendor/Export2Excel').then((excel) => {
        if (
          type == 'total_vehicle' ||
          type == 'moving_vehicle' ||
          type == 'parking_vehicle' ||
          type == 'unreported_vehicle'
        ) {
          var tHeader = [
            'No',
            'Device Name',
            'Imei',
            'GSM No',
            'Last Update',
            'Speed',
            'Expired',
            'Lon',
            'Lat',
            'Address',
            'Lifetime Warranty'
          ]

          var filterVal = [
            'no',
            'device_name',
            'imei',
            'gsm_no',
            'server_time',
            'speed',
            'expired_gsm',
            'lon',
            'lat',
            'address',
            'lifetime_warranty'
          ]

          if (type == 'total_vehicle') {
            tHeader.push('POI')
            filterVal.push('poi_name')
          }

          if (type == 'unreported_vehicle') {
            tHeader.splice(1, 0, 'Username')
            tHeader.join()

            filterVal.splice(1, 0, 'username')
            filterVal.join()
          }
        } else if (type == 'expired_soon' || type == 'expired') {
          var tHeader = [
            'No',
            'Username',
            'Email',
            'Phone',
            'Plate',
            'Device Name',
            'GSM NO',
            'Imei',
            'Last Update',
            'Expired',
            'Lifetime Warranty'
          ]

          var filterVal = [
            'no',
            'username',
            'email',
            'phone',
            'plate',
            'device_name',
            'imei',
            'gsm_no',
            'server_time',
            'expired_gsm',
            'lifetime_warranty'
          ]
        }

        const list = this.dataVehicle
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: `${type}_${parseInt(this.now)}`,
          autoWidth: true,
          bookType: 'xlsx'
        })
        this.$vs.loading.close(`#exportBtn2 > .con-vs-loading`)
      })
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    }
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
